import React, { useEffect } from 'react';
import 'katex/dist/katex.min.css';
import renderMathInElement from 'katex/dist/contrib/auto-render.js';
import { applyKatexWrap, flattenKatexUnderlines } from 'global/katexWrap';

import './index.css';

type TableGridPreviewProps = {
    question: any;
    showAnswer: boolean;
};

function TableGridPreview({ question, showAnswer } : TableGridPreviewProps) {
    const renderKatex = () => {
        const katex = document.getElementsByClassName('katex');
        for (let i = 0; i < katex.length; i++) {
            renderMathInElement(katex[i], {
                delimiters: [
                    {left: '$$', right: '$$', display: true},
                    {left: '$', right: '$', display: false},
                    {left: '\\(', right: '\\)', display: false},
                    {left: '\\[', right: '\\]', display: true}
                ],
                trust: true
            });

            katex[i].innerHTML = katex[i].innerHTML.replaceAll('&nbsp;', ' ');
        }

        // Wraps unconditionally (the subject test was commented out before this
        // helper existed). Kept as-is; the array guard inside is what matters.
        applyKatexWrap(document, { enabled: true });

        flattenKatexUnderlines(document);

        const math = document.querySelectorAll('.katex-mathml');
        for (let i = 0; i < math.length; i++) {
            math[i].remove();
        }
    }

    useEffect(() => {
        renderKatex();
    }, [showAnswer]);

    return (
        <table className={showAnswer
            ? 'digitalSHSATReview__tableGridShowAnswer'
            : 'digitalSHSATReview__tableGrid'
        }>
            <tbody>
                <tr>
                    <th></th>
                    {question.tableGridColumns.map(column => (
                        <th key={`c${column.id}`}><p className='katex'>{column.name}</p></th>
                    ))}
                </tr>
                {question.tableGridRows.map(row => (
                    <tr key={`r${row.id}`}>
                        <th><p className='katex'>{row.name}</p></th>
                        {question.tableGridColumns.map(column => (
                            <td key={`r${row.id}c${column.id}`}>
                                <input
                                    type='checkbox'
                                    checked={showAnswer
                                        ? (
                                            (question.answers.find(item => (
                                                item[0] === row.id && item[1] === column.id
                                            ))) ? true: false
                                        )
                                        : false
                                    }
                                />
                            </td>
                        ))}
                    </tr>    
                ))}
            </tbody>
        </table>
    );
}

export default TableGridPreview;